import { Button, Dialog, DialogContent, Grid, Typography } from '@mui/material'

import type { FC } from 'react'

export interface DeleteConfirmationDialogProps {
	title: string
	message: string
	onRemove: () => void
	onCancel: () => void
	isOpen: boolean
	maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
	isRemoving?: boolean
}

export const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
	isOpen,
	onCancel,
	title,
	message,
	onRemove,
	maxWidth = 'sm',
	isRemoving,
}) => {
	return (
		<div data-testid="delete-dialog">
			<Dialog
				open={isOpen}
				onClose={() => {
					onCancel()
				}}
				fullWidth
				maxWidth={maxWidth}
			>
				<DialogContent>
					<Grid container spacing={2}>
						<Grid>
							<Typography variant="h6" component="h2" data-testid="delete-dialog-title">
								Remove {title}
							</Typography>
						</Grid>
						<Grid>
							<Typography variant="body1" component="p" data-testid="delete-dialog-message">
								{message}
							</Typography>
						</Grid>
						<Grid container spacing={1} justifyContent="flex-end">
							<Grid>
								<Button
									variant="text"
									onClick={() => {
										onCancel()
									}}
									color="inherit"
									data-testid="delete-dialog-cancel-button"
								>
									Cancel
								</Button>
							</Grid>
							<Grid>
								<Button
									variant="contained"
									onClick={onRemove}
									color="error"
									data-testid="delete-dialog-remove-button"
									disabled={isRemoving}
								>
									{isRemoving ? 'Removing...' : 'Remove'}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
			</Dialog>
		</div>
	)
}
